import React from "react";
import { CheckIcon, MailIcon, ShieldCheckIcon } from "lucide-react";
import { CheckoutButton } from "./CheckoutButton";
import { ProductVisual } from "./ProductVisual";
import { Accent, Container, SectionHeader } from "./ui";
import { checkout, offerIncluded, productName } from "../data/content";
export function OfferDetails() {
  return <section id="offer-details" className="bg-petrol-deep py-12 text-white md:py-20" data-id="element-100" data-mp="3iil5dqo97u6j">
      <Container data-id="element-101" data-mp="jymdqooqpa0p">
        <SectionHeader tone="dark" eyebrow="Your activity kit" title={<>
              Make your next activity <Accent tone="dark" data-id="element-103" data-mp="a0f7p0vzocdh">easier to prepare</Accent>
            </>} data-id="element-102" data-mp="jx1tpt01x9h3" />

        <div className="mx-auto max-w-[600px] rounded-2xl bg-white px-4 py-7 text-ink shadow-[0_24px_60px_rgba(0,0,0,0.25)] sm:px-10 sm:py-10" data-id="element-104" data-mp="5zwfh5q6p4ar">
          <div className="text-center" data-id="element-105" data-mp="2usqrr6w421l8">
            <h3 className="font-display text-[30px] font-extrabold uppercase leading-[0.95] text-petrol sm:text-[38px]" data-id="element-106" data-mp="2qpu6t9j3lte4">
              {productName}
            </h3>
            <p className="mt-2 text-[15px] text-muted" data-id="element-107" data-mp="37ggk1fliak7h">1 activity book + 12-month calendar + 5 practical bonuses</p>
          </div>

          <ProductVisual className="mt-6" data-id="element-108" data-mp="2yf8v3o4vqvq2" />

          <ul className="mt-7 space-y-3 border-t border-line pt-7" data-id="element-109" data-mp="2ye77kk6oggrg">
            {offerIncluded.map(item => <li key={item} className="flex items-start gap-3 font-medium text-ink" data-id="element-110" data-mp="32er4bmnc9id2">
                <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sage" data-id="element-111" data-mp="2onkxt6ln6kgo">
                  <CheckIcon className="h-3.5 w-3.5 text-petrol" strokeWidth={3} aria-hidden="true" data-id="element-112" data-mp="2thywpizij9q3" />
                </span>
                {item}
              </li>)}
          </ul>

          <div className="mt-7 border-t border-line pt-7 text-center" data-id="element-113" data-mp="2jqcdazd0u4c9">
            <p className="flex items-end justify-center text-petrol" data-id="element-114" data-mp="25rmglku466of">
              <span className="mb-2 font-display text-[36px] font-extrabold leading-none sm:text-[40px]" data-id="element-115" data-mp="2apwdbzvhlfc5">$</span>
              <span className="font-display text-[88px] font-extrabold leading-[0.8] tracking-[-0.02em] sm:text-[104px]" data-id="element-116" data-mp="g9fr3mcg8d40">
                {checkout.price}
              </span>
              <span className="mb-1 ml-2 text-sm font-semibold text-ink" data-id="element-117" data-mp="6j3b87fkx847">{checkout.currency}</span>
            </p>
            <p className="mt-4 text-sm font-semibold text-muted" data-id="element-118" data-mp="2iayh47i0l36">One-time payment. No subscription.</p>
          </div>

          <div className="mt-6" data-id="element-119" data-mp="z6z2gwmdq7tl">
            <CheckoutButton label={`Get my complete kit — $${checkout.price}`} className="w-full" data-id="element-120" data-mp="z5xskvh3nrdg" />
            <p className="mt-2 text-center text-[13px] text-muted" data-id="element-121" data-mp="u6ull5hk7b2u">Digital PDFs in English · No physical shipping</p>
            <p className="mt-1.5 flex items-center justify-center gap-1.5 text-center text-[13px] font-medium text-ink" data-id="element-122" data-mp="l8999s2oksai">
              <ShieldCheckIcon className="h-4 w-4 shrink-0 text-petrol" aria-hidden="true" data-id="element-123" data-mp="3ay476wvl8s9o" />
              Covered by our 10-day money-back guarantee
            </p>
          </div>

          <p className="mt-6 flex items-start gap-2 rounded-xl bg-cream p-4 text-left text-[13px] text-ink" data-id="element-124" data-mp="1lgfqsvlop7el">
            <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-petrol" aria-hidden="true" data-id="element-125" data-mp="1qfadw9qopi4i" />
            Your download details will be sent to the email address you provide at checkout.
          </p>
        </div>
      </Container>
    </section>;
}